import { IKeHoachThucTapActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachThucTapReducer } from "../../reducer-model/xet-thuc-tap/IKeHoachThucTapReducer";

const iniState: IKeHoachThucTapReducer = {
    status: eReducerStatusBase.is_not_initialization,
    isShowEditModal: false,
    keHoachThucTaps: [],
    keHoachThucTapEdit: null,
}

export const keHoachThucTapReducer = (state: IKeHoachThucTapReducer = iniState, action: IKeHoachThucTapActionTypes): IKeHoachThucTapReducer => {
    switch (action.type) {
        case "KE_HOACH_THUC_TAP_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "KE_HOACH_THUC_TAP_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachThucTaps: action.payload
            };
        case "KE_HOACH_THUC_TAP_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "KE_HOACH_THUC_TAP_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "KE_HOACH_THUC_TAP_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "KE_HOACH_THUC_TAP_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "KE_HOACH_THUC_TAP_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "KE_HOACH_THUC_TAP_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                keHoachThucTapEdit: action.payload
            };
        case "KE_HOACH_THUC_TAP_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                keHoachThucTapEdit: null
            };
        case "KE_HOACH_THUC_TAP_UPDATE_ACTIVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "KE_HOACH_THUC_TAP_UPDATE_ACTIVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "KE_HOACH_THUC_TAP_UPDATE_ACTIVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}